import { render, staticRenderFns } from "./PromotionSettings.vue?vue&type=template&id=7959993c&scoped=true&"
import script from "./PromotionSettings.vue?vue&type=script&lang=js&"
export * from "./PromotionSettings.vue?vue&type=script&lang=js&"
import style0 from "../../../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=7959993c&scoped=true&lang=css&"
import style1 from "./PromotionSettings.vue?vue&type=style&index=1&id=7959993c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7959993c",
  null
  
)

export default component.exports